module.exports = __webpack_public_path__ + "img/11.15f7ab4c.png";